import { RetryIcon } from "./Icons";
import ui from "./ui.module.css";

// Calm, blame-free retry in the Teacher App's sheet style. Nothing moves on
// until the save is confirmed.
const RetryPanel = ({ onRetry, saving }) => (
  <div className={ui.sheetBackdrop}>
    <div className={ui.sheet} role="alertdialog" aria-labelledby="retry-title">
      <span className={`${ui.bigIcon} ${ui.bigIconGold}`}>
        <RetryIcon size={64} />
      </span>
      <h2 id="retry-title" className={ui.learnerTitle}>
        Let's try that again
      </h2>
      <button
        type="button"
        className={`${ui.button} ${ui.large} ${ui.primary} ${ui.full}`}
        onClick={onRetry}
        disabled={saving}
        autoFocus
      >
        {saving ? "Trying…" : "Try again"}
      </button>
    </div>
  </div>
);

export default RetryPanel;
